<template>
  <v-app
    style="background: #ebebeb; width: 100vw !important; position: absolute"
  >
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import canvas_bg from "./assets/canvas_bg.png";

export default {
  name: "App",
  data() {
    return {
      background: canvas_bg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "styles/p3.scss";
</style>
